__webpack_require__.p = "https://ambitious-bush-038f8cf03.5.azurestaticapps.net/";